import { makeStyles, shorthands } from '@fluentui/react-components';

export const useStyles = makeStyles({
  urlInputContainer: {
    display: 'flex',
    flexWrap: 'nowrap',
    width: 'auto',
    height: 'auto',
    boxSizing: 'border-box',
    '> *': {
      textOverflow: 'ellipsis',
    },
    ...shorthands.gap('16px'),
  },
  urlInput: {
    height: 'auto',
    width: 'auto',
    flexGrow: 1,
  },
  urlProtocol: {
    minWidth: 'unset',
  },
  customUrlProtocol: {
    width: '100px',
  },
  urlPath: {
    display: 'flex',
    flexWrap: 'wrap',
    wordBreak: 'break-all',
    alignItems: 'baseline',
    ...shorthands.gap('6px'),
  },
});
